import { useEffect, useRef, useState } from 'react'

/** Доля полосы, которую занимает отправка байтов; остальное — ожидание ответа сервера. */
const SEND_SHARE = 0.7
/** Выше этого полоса не поднимется, пока сервер не ответил. */
const WAIT_CAP = 95
const TICK_MS = 120

/**
 * Показываемый процент загрузки. Браузер отчитывается только об ОТПРАВКЕ байтов:
 * маленькая картинка «уходит» мгновенно, и подпись сразу показывала 100%, хотя сервер
 * ещё сжимает файл. Здесь отправка занимает первые 70% полосы, дальше процент
 * подползает к 95, замедляясь, — до ответа сервера (`real === null` — загрузка кончилась).
 */
export const useSmoothProgress = (real: number | null): number | null => {
  const [shown, setShown] = useState<number | null>(real === null ? null : 0)
  const realRef = useRef(real)
  realRef.current = real

  const active = real !== null
  useEffect(() => {
    if (!active) {
      setShown(null)
      return
    }
    setShown(0)
    const id = window.setInterval(() => {
      const r = realRef.current ?? 0
      setShown((prev) => {
        const p = prev ?? 0
        const sendTarget = r * SEND_SHARE
        // Отправка ещё идёт — догоняем её; ушла целиком — ползём к потолку.
        const target = r >= 100 ? WAIT_CAP : Math.max(sendTarget, p)
        const step = r >= 100 ? (WAIT_CAP - p) * 0.04 : (target - p) * 0.35
        return Math.min(WAIT_CAP, p + Math.max(step, 0))
      })
    }, TICK_MS)
    return () => window.clearInterval(id)
  }, [active])

  return shown
}
